/*
 * @Author: Axs <i@axs.email>
 * @Date: 2020-08-04 20:51:36
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-07-01 17:05:43
 * @Description:
 * @FilePath: /src/lib/page.js
 */
const BASE_URL = process.env.VUE_APP_BASE_URL;
// 根目录
export const PAGE_ROOT = BASE_URL + '/';
// tabbar 名称前缀
export const PAGE_TABBAR_NAME = BASE_URL + '/main';
// tabar 默认重定向
export const PAGE_TABBAR_DEFAULT_REDIRECT = BASE_URL + PAGE_MAIN_MOVIE;
// 电影
export const PAGE_MAIN_MOVIE = PAGE_TABBAR_NAME + '/movie';
// 影院
export const PAGE_MAIN_CINEMA = PAGE_TABBAR_NAME + '/cinema';
// 我的
export const PAGE_MAIN_MY = PAGE_TABBAR_NAME + '/my';
// 设置密码
export const PAGE_SET_PASSWORD = BASE_URL + '/set/password';
// 设置定位
export const PAGE_SET_CITY = BASE_URL + '/set/city';
// 订单列表
export const PAGE_ORDER_LIST = BASE_URL + '/order/list';
// 订单详情
export const PAGE_ORDER_INFO = BASE_URL + '/order/info';
// 电影信息
export const PAGE_MOVIE_INFO = BASE_URL + '/movie/info';
// 电影选座
export const PAGE_MOVIE_SEAT_SELECTION = BASE_URL + '/movie/seat/selection';
// 影院信息
export const PAGE_CINEMA_INFO = BASE_URL + '/cinema/info';
// 订单支付页
export const PAGE_PAY = BASE_URL + '/pay';
// 客服页面
export const PAGE_CUSTOMER_SERVICE = BASE_URL + '/customer-service';
// 选择出票方式
export const PAGE_TICKET_TYPE = BASE_URL + '/order/ticket/type';
// 地图
export const PAGE_MAP = BASE_URL + '/map';
// 微信直接回掉页面
export const PAGE_PAY_CENTER_PAGE = BASE_URL + '/pay-center-page';
// 其他域名公共的微信支付
export const PAGE_WECHAT_PAY = BASE_URL + '/wechat/pay';
// 优惠券列表
export const PAGE_COUPON_LIST = BASE_URL + '/coupon/list';
// 选择可用的优惠券
export const PAGE_COUPON_SELECT = BASE_URL + '/coupon/select';
// 竞价页面
export const PAGE_ORDER_BID = BASE_URL + '/order/bid';
// 申请成为供应商
export const PAGE_APPLY_SUPPLIER = BASE_URL + '/apply/supplier';
